import {useRouleeteSocket} from '@/socket/game/roulette.ts';
import { useAutoOptionStore } from '~/stores/cansino/autoOption';
import {betableCheck} from '@/common/js/betHelper';
import {oAmountTips} from '@/common/js/constant'; 
import {fnChipsManager} from './rouletteFn';

const {EMIT_ROULETTE_BET} = useRouleeteSocket();
const isDev = import.meta.dev;

// ↓ 拖动相关方法 
const oDragAndDrop = {
    // ↓ 手动时点亮对应目标
    allowDrop(ev, oChip) {
        ev.preventDefault();
        this.optionAnimation(oChip);
    },
    // ↓ 拿起
    drag(ev, idx) {
        // const oChip = this.aOptionList[idx]
        // console.log(deepCopy(oChip));
        ev.dataTransfer.setData('iOptionIndex', idx);
    },
    // ↓ 放下 
    drop(ev, oChip) {
        ev.preventDefault();
        // console.log("dropped\n", ev);
        var idx = ev.dataTransfer.getData("iOptionIndex");
        const oFrom = this.aOptionList[idx] || { placed: 0 };
        this.recordHistory();
        this.oMusic.oAudio.chipsSet.toPlay();
        oChip.placed += oFrom.placed;
        oFrom.placed = 0;
    },
};


// ↓移动端的方法
const oMobileFn = {
    onTouchEnd(ev) {
        clearTimeout(this.touchStartTimer);
        // ↑ 先清除
        const iGap = (this.touchStartItem?.ts || 0) - Date.now();
        // console.log("onTouchEnd--", iGap);
        // ↓ 长按事件，防止弹出长按菜单 
        if (iGap > 200){
            ev.preventDefault();
        }
        this.touchStartItem = null;
        this.touchStartTimer = null;
    },
    onTouchStart(ev, oChip) {
        clearTimeout(this.touchStartTimer);
        // ↑ 先清除
        const ts = Date.now();
        this.touchStartItem = { ...deepCopy(oChip), ts };
        // ↓ 按了 600ms 说明要删除，执行删除
        this.touchStartTimer = setTimeout(()=>{
            const isSameTarget = ts === this.touchStartItem?.ts;
            console.log("正在长按，有效性：", isSameTarget); 
            if (!isSameTarget) return;
            this.oMusic.oAudio.undo.toPlay();
            this.touchStartItem = null;
            this.clickOnOption(oChip, {
                withdraw: true,
            });
        }, 600); // 系统默认的长按事件是500毫秒 
        if ((ev.cancelable) && 'ontouchstart' in window) {
            ev.preventDefault();
        }
    },
};


// ↓ 由用户触发的方法
const oFn4User = {
    toChangeMode(isAuto){
        this.isAutoMode = !!isAuto;
        if (isAuto){
            this.oAutoDialog.switchAutoDialogVisible(true);
        }
    },
    slideCoinList(sMark){
        
    },
    // ↓ 分发下注事件
    butButtonClick01(){
        // ↓没钱不能下注
        if (!this.oForm.amount) return;
        if (this.isAutoMode){
            if (this.oForm.isSubmiting){
                this.oForm.isSubmiting = false;
                this.stopInfinity();
            }else{
                // ↓ 在自动模式启动之前需要记录“初始值” 用于后续的金额复位操作 
                const arr = deepCopy(this.aOptionList)
                this.aOptionListInitial4AutoMode = arr;
                this.startInfinity();
            }
        }else{
            const res = this.submitTheBet();
            return res;
        }
    },
    // ↓ 下注金额翻倍或减半
    changeAmount(
        sCommand,
        increaseMutiple = 0, // 接收 1.5, 2.3 这样的上涨倍数，用于自动模式的上涨 
    ){
        const doubling = sCommand === 'double'; // double | half
        let {min, max} = this.getBetLimit(increaseMutiple);
        const {amount} = this.oForm;
        if (!amount) return;
        let iAllCoinsQty = 0; // 已经下注的筹码数量
        // 以下是 "上涨后的金额将超过规定的上限" 的2种情况 
        const bMoreThanHalf = amount * 2 > max; // ✨情况1
        const beyoundTheMax = amount * increaseMutiple > max; // ✨情况2
        let iAmountRest = Math.max(0, max - amount); // 下注上限 - 已经下注金额 
        let iCoinsRest = Math.floor(iAmountRest / min); // 尚可下注的筹码数量
        const {balance} = this.oUserStore.oNowCurrency;
        const iAimValue = (()=>{ // ←计划上涨后的金额 
            if (!doubling) return 0; // 金额削减中，返回0
            if (bMoreThanHalf || beyoundTheMax) {
                return max; // ← 返回押注上限值 
            }
            if (increaseMutiple > 1){
                return amount * increaseMutiple
            }
            return amount * 2; // ← 翻倍后的金额
        })();
        // 要翻倍，余额不足，无法翻倍
        if (doubling && (iAimValue > balance)){
            console.warn('余额不足，无法上涨'); 
            if (!this.isAutoMode){ // 仅手动模式有弹出提示  
                showToastIfNeeded(oAmountTips.reachedUserBalance);
            }
            return;
        }
        // console.log(`剩余信息： ${iAmountRest} / ${min} = ${iCoinsRest.toLocaleString()}`);
        // ↓ 累积求和
        this.aOptionList.forEach(cur => {
            iAllCoinsQty += (cur.placed || 0); 
        });
        if (doubling){
            this.oMusic.oAudio.chipsSet.toPlay();
        }
        // ↓ 保存历史记录
        this.recordHistory();
        let toast = ''; 
        this.aOptionList.forEach(cur => {
            if (!cur.placed) return;
            let iNewVal  = 0;
            if (doubling){ // 翻倍
                if (bMoreThanHalf || beyoundTheMax){
                    const fRate = cur.placed / iAllCoinsQty; // 占比
                    let iAddation = Math.max(0, iCoinsRest * fRate); // 按占比增加
                    // console.log(`占比信息：${cur.placed} / ${iAllCoinsQty} = ${fRate} = ${iAddation}个`); 
                    iNewVal = cur.placed + iAddation;
                    toast = oAmountTips.reachedUpperLimit;
                } else if (increaseMutiple > 1) {
                    iNewVal = cur.placed * increaseMutiple;
                }else{
                    iNewVal = cur.placed * 2;
                }
            }else{ // 减半
                iNewVal = cur.placed * 0.5;
            }
            iNewVal = Math.max(0, iNewVal);
            iNewVal = Math.floor(iNewVal);
            cur.placed = iNewVal;
        });
        if (!this.isAutoMode && toast){ // 仅手动模式有弹出提示  
            showToastIfNeeded(toast);
        }
        // ↓ 返回上涨之后的金额,自动模式时需要用 
        return this.calculateFormAmount();
    },
    // ↓ 用于自动模式： “金额上涨” 
    // ↓ 供自动模式方法包调用 
    fnIncrease(multiple){
        const fAmountOld = this.oForm.amount;
        // ↓ 余额不足时无返回值，属正常现象 
        const fAmountNew = this.changeAmount('double', multiple);
        if (!fAmountNew || (0 && isDev)){
            const {balance} = this.oUserStore.oNowCurrency;
            console.warn(`自动下注模式要求将金额上涨，详情如下:`); 
            console.log(`${fAmountOld} * ${multiple} = ${fAmountNew} (用户余额：${balance})`); 
        }
        if (!fAmountNew){
            console.warn('自动模式金额上涨成功');
            return fAmountOld; // 用旧金额
        }
        return fAmountNew;
    },
    // ↓ 用于自动模式的： “金额复位” 
    fnReset(){
        const arr = deepCopy(this.aOptionListInitial4AutoMode);
        this.aOptionList = arr;
        this.oForm.amount = this.calculateFormAmount();
        return this.oForm.amount;
    },
    // ↓ 切换筹码（此举将会变更每次点击的下注额度  
    setChipInUse(iCionIndex){
        if (this.aCoinList[iCionIndex].sTip) { // 通过判断表示此项被禁用了
            return; 
        }
        this.iCoinInUse = iCionIndex;
        this.aCoinList.forEach((cur, idx)=>{
            cur.inUse = idx === iCionIndex;
        });
    },
    // ↓ 押注，或取消押注（内部会生成历史记录）
    clickOnOption(oOpt, oConfig={}){
        console.log('押注目标：\n', deepCopy(oOpt), '\n', deepCopy(this.oCoinInUse)); 
        this.oGameResult = deepCopy(this.oGameResultEmpty);
        const { withdraw, toRecard=true } = oConfig;
        const {min, max} = this.oBetLimit;
        // console.log('this.oBetLimit：\n', deepCopy(this.oBetLimit));
        // console.log('this.oBetLimit：\n', min, max); 
        // ↓ 金额减少中
        // ↓ 用户没有余额或达到了上限 
        if (!this.choosable && !withdraw){
            return this.optionAnimation(oOpt, true); // 晃动
        }
        const oCoinInUse = this.oCoinInUse;
        let iStep = oCoinInUse.value; // 增减的步幅
        if (withdraw === true){ // 减
            iStep *= -1; 
        }else{ // 加
            this.oMusic.oAudio.chipsSet.toPlay();
            const iFormAmount = this.calculateFormAmount();
            // ↓ 尚可下注的筹码数量
            const iCoinsRest = Math.floor(
                (this.oBetLimit.max - iFormAmount) / this.oBetLimit.min
            ); 
            iStep = Math.min(iStep, iCoinsRest);
        }
        let iNewVal = Math.floor(oOpt.placed + iStep);
        if (iNewVal < 0) iNewVal = 0;
        if (toRecard) this.recordHistory();
        oOpt.placed = iNewVal;
    },
    // ↓ 点击左侧的4类特定群组 
    async clickOnSpecialOpt(oOption){
        const oOpt = deepCopy(oOption);
        // console.log("oOpt", oOpt);
        const {label} = oOpt;
        const aList = [];
        this.aOptionList.forEach((cur, idx) => {
            const isThisOne = (cur.represent||'').includes(label);
            if (!isThisOne) return;
            aList.push({
                idx,
                minVal: (()=>{
                    if (cur.refer2) return Math.min(...cur.refer2);
                    return cur.value;
                })(),
            });
        });
        aList.sort((aa, bb) => aa.minVal - bb.minVal);
        for (const cur of aList){
            await Sleep(160);
            await nextTick();
            const oTarget = this.aOptionList[cur.idx];
            // ↓ 委托特定方法完成，此方法内会创建历史记录
            this.clickOnOption(oTarget);
        }
    },
    // ↓ 撤销一步
    goBackward(){
        this.oMusic.oAudio.undo.toPlay();
        let oLastOne = this.aHistory.pop();
        if (!oLastOne) return;
        this.aOptionList = deepCopy(oLastOne);
        this.mouseLeaveOption(); 
    },
    // ↓ 清空选择
    clearAllOption(){
        this.oGameResult = deepCopy(this.oGameResultEmpty);
        this.aOptionList.forEach(cur => {
            cur.placed = 0;
        });
        this.aHistory.splice(0, 1/0);
        this.oMusic.oAudio.clear.toPlay();
        this.mouseLeaveOption(); 
    },
    // ↓ 点亮对应选项，或震动选项 
    optionAnimation(oTarget, shake){
        const {areaName, refer2} = oTarget;
        const iValue = Number(oTarget.value);
        if (!refer2 && isNaN(iValue)) {
            return; // 按道理，不会到达这里
        }
        const arr = refer2 || [iValue];
        const toShake = shake === true;
        if (toShake){
            this.aShaking.splice(0, 1/0, ...arr);
            if (areaName) this.aShaking.push(areaName);
            setTimeout(() => {
                this.aShaking.splice(0, 1/0); // 用于清除类名 
            }, 500);
        }else{
            this.aHovering = arr;
        }
    },
    // ↓ 鼠标“离开” 清空选项（清空高亮效果）  
    mouseLeaveOption(){
        this.aHovering = [];
    },
};

// ↓ 下注相关方法 
const oAboutPlaceBet = {
    // ↓提交下注结果
    async submitTheBet(){
        if (!betableCheck(this.oForm.amount)) return;
        clearTimeout(this.timerOfHidingMobileResult);
        this.isRolling = true; // 锁定
        this.showMobileResult = true; // 在移动端显示大转盘 
        this.oGameResult = deepCopy(this.oGameResultEmpty); // 归零
        await this.$nextTick();
        // ↑ 赋值 ==================================================
        const oParams = this.getParamsToSubmit();
        const ts = this.oUserStore.queueStart(); // 阻止余额立即变化
        const t01 = Date.now();
        this.oJoinStateStore.gameRunning = true;
        fnChipsManager('set', this.aOptionList); 
        // if (import.meta.env.DEV_MODE && this.isAutoMode && Math.random() <= 0.3){
        //     oParams.amount = 0; // 测试 
        // }
        const oResult = await EMIT_ROULETTE_BET(oParams);
        const hasError = (
            !oResult
            || oResult.code === '1000'
            || oResult.error
        );
        if (hasError){
            this.oUserStore.queueDelete(ts);
            this.oJoinStateStore.gameRunning = false;
            this.isRolling = false;
            this.showMobileResult = false;
            if (!this.isAutoMode){ // 仅为手动模式弹出，自动模式由方法包弹出  
                showNegativeNotify(oResult?.error); 
            }
            return oResult;
        }
        const response = (oResult || {}).response || {};
        if (response.roll_number >= 0 === false){
            this.oForm.isSubmiting = false; // 减半自动下注
            if (isDev){
                console.error('下注未成功\n', oParams);
            }
        }
        response.roll_number *= 1; // 字符转整形
        const hasWon = response.multi > 0; // > 0 视为赢
        // console.log("是否赚了：", hasWon); 
        await this.spinTo(response.roll_number); // 等动画播放完成 
        if (!this.oForm.isSubmiting){
            this.oJoinStateStore.gameRunning = false;
        }
        this.oGameResult = {
            ...response,
            bVisible: true, // ← 无论输赢都要显示结果
        };
        this.isRolling = false;
        this.oUserStore.queueForward(ts); // 显示余额变化
        this.oJoinStateStore.showDateInQueue(); // 插入游戏结果并播放动画
        console.log("开奖结果：", deepCopy(response)); 
        console.log(oResult);
        if (hasWon){
            this.oMusic.oAudio.wind.toPlay();
        }else{
            this.oMusic.oAudio.lose.toPlay();
        }
        // ↓ 自动下注模式时要间隔一段时间，让游戏结果在画面上逗留一会儿然后再启动下一局
        const iDelay = this.oForm.isSubmiting ? 800: 0; 
        await Sleep(iDelay); // 自动模式加一点间隔用于显示游戏结果，
        return {
            amount: this.oForm.amount, // 下注金额
            winAmount: response.winAmount, // 赢钱金额（可以是0）
        };
    },
    // ↓ 取得“用于提交” 下注的数据
    getParamsToSubmit(){
        const {min} = this.oBetLimit;
        const oParams = {
            amount : String(this.calculateFormAmount()), // 提交前计算一下，更准确
            frontID : Date.now(),
            isFast : this.isFast,
            prediction: [],
        };
        oParams.prediction = this.aOptionList.filter(oCur => {
            return oCur.placed > 0;
        }).map(cur=>{
            const oResult = {
                "amountChip": cur.placed, // 投注筹码数量
                "amount": String(cur.placed * min), // 数量*单价
                "cells": (() => { // 下注范围
                    if (cur.areaName) return [cur.areaName]; // 一定放在第1行
                    if (cur?.refer2?.length) return cur.refer2;
                    if (cur.value >= 0) return [cur.value];
                    if (isDev) {
                        console.error('未能取得目标值');
                        return [];
                    }
                })(),
            };
            return oResult;
        });
        return oParams;
    },
    // ↓整理历史数据用于显示
    useHistoryData(oData){
        this.clearAllOption(); // 先清空 
        oData.prediction.forEach(oCurOption => {
            const {strVal} = oCurOption;
            const oTarget = this.aOptionList.find(cur => {
                return strVal == cur.sValueSign;
            });
            if (!oTarget) {
                console.error('找不到目标');  
                return;
            }
            // isDev && console.log('选择与目标', strVal, deepCopy(oTarget));  
            oTarget.placed = oCurOption.amountChip; 
        });
        // console.log("遍历完毕，已经为 this.aOptionList 赋值");
        const iRollNumber = Number(
            oData?.randomSeed?.split('_')?.[0]
        );
        this.oGameResult.roll_number = iRollNumber; 
    },
}

// ==========================================================================================

// ↓ 由程序调用的方法
const oFn4Program = {
    // ↓ 取得上注金额上限
    getBetLimit(increaseMutiple){
        let {min, max} = this.oBetLimit;
        const {maxBetAmount} = useAutoOptionStore(); // 自动模式下注金额上限
        const arr01 = [
            this.isAutoMode, // 自动模式
            maxBetAmount > 0, // 设定了上涨金额上限
            maxBetAmount < max, // 此上限小于游戏设定的上限值
            increaseMutiple > 1, // 需要上涨
        ];
        if (arr01.every(Boolean)){
            max = maxBetAmount;
        }
        console.log("min,max=", min, max);
        return {min, max};
    },
    // ↓ 用户下注后计算金额
    calculateFormAmount(){
        let fResult = 0; // 下注筹码对应的金额 
        this.aOptionList.forEach(cur => {
            if (cur.placed > 0){
                fResult += (cur.placed * this.oBetLimit.min);
            }
        });
        // ↓ 此值初步判断不便使用 beFixed() 因为会导致前端后计算值不同，导致报错，留用 toFixed() 
        fResult = Number(fResult.toFixed(8));
        // console.log("✨ 新金额：", fResult); 
        return fResult;
    },
    recordHistory(){
        // 使用 freeze() 冻结，防止被修改
        const oHistory = Object.freeze( 
            deepCopy(this.aOptionList),
        );
        this.aHistory.push(oHistory); // 保存历史记录
    },
    // ↓ 取得类名，类名可点亮按钮，或抖动按钮
    getBtnActiveClassName(cur){
        const chosing = this.aHovering.includes(cur.value);
        const shaking = (
            this.aShaking.includes(cur.value)
            || this.aShaking.includes(cur.areaName)
        );
        // ↓ 返回 true 表示，如果选了这个选项将赢钱（在开奖之后亮点）
        const letYouWin = (() => {
            if (cur.hidden) return false; // 不可见元素
            const aRefer = cur.refer2 || [cur.value];
            return aRefer.includes(this.oGameResult.roll_number);
        })();
        const oResult = {}; // 最终类名
        // ↓ 点亮按钮的2个条件
        if (chosing) {
            if (cur.value === 0) oResult['slot-0--active'] = true;
            oResult[`board__bets__item--${cur.color}--active`] = true;
        }
        if (letYouWin && this.oGameResult.roll_number >= 0){
            oResult['won-on'] = true;
        }
        if (shaking){
            oResult.showDrag = true;
        }
        return oResult;
    },
    // ↓ 计算
    getCoinImg(oOpt){
        const aCoinReverse = this.aCoinReverse;
        for (const cur of aCoinReverse){
            if (oOpt.placed >= cur.value){
                return cur.img;
            }
        }
    },
    // ↓ 加载上次下注的布局 
    useChipsRecord(){
        if (this.type == 'result') return; 
        const aRecord = fnChipsManager('get');
        if (!aRecord || !aRecord.length) return; 
        // console.log('开始加载本地下注历史：', aRecord); 
        aRecord.forEach((oHis, idx)=>{
            const aMatched = this.aOptionList.filter(cur=>{
                const arr = [
                    oHis.value == cur.value,
                    oHis.title == cur.title,
                    oHis.hidden == cur.hidden,
                    oHis.areaName == cur.areaName,
                    oHis.sValueSign == cur.sValueSign,
                ];
                return arr.every(Boolean); 
            });
            const [oMatched, oSecond] = aMatched;
            if (!oMatched || oSecond){
                console.error('历史数据配对异常');
                console.log('历史', deepCopy(oSecond));
                console.log('本地', deepCopy(oMatched), deepCopy(oSecond));
                return; 
            }
            oMatched.placed = oHis.placed;
        });
    },
};

// ↓外来方法
const oFnBorrowed = {
    toDrawTheBall(){
        const oCanvas = this.$refs.canvas;
        if (!oCanvas) return;
        console.log('开始绘制小球 ⚽');
        const oBall = new BallMaker();
        oBall.init(oCanvas); // 绘制小白球
        fnCanvasAnimationRunner(oBall); // 启动循环
        this.oBall_N = oBall; // 保存小白球
    },
    // ↓旋转到目标坑位 
    async spinTo(iResult) {
        let fnRoslve = xx => xx; // ← 用于宣告动画播放完毕
        const oPromise = new Promise(f1 => fnRoslve = f1);
        const iRollTo = n2n[iResult];
        const r = 2 * 360; // 转2圈？
        if (!this.oBall_N) {
            this.toDrawTheBall();
        }
        this.oBall_N.startAnim();
        const angleValue = (
            this.angle
            - (this.angle % 360)
            + r
            + (360 / 37 * iRollTo)
        );
        this.angle = angleValue;
        // ↓ 在 css 中为旋转动画设定的耗时是 3.7s 
        // ↓ 这个 3.7s 不要修改，因为此值要与音效时长对应起来 
        let iDelay = this.isFast ? 500 : (3_700 + 200);
        setTimeout(() => {
            fnRoslve(true);
            // if (!this.mobileMode) return;
            this.timerOfHidingMobileResult = setTimeout(() => {
                // console.log('自动下注标记：', this.oForm.isSubmiting);
                if (this.oForm.isSubmiting == false){
                    // ↓ 在移动端时凭此关闭转盘，显示出投注选项 
                    this.showMobileResult = false;
                }
            }, 1_700);
        }, iDelay);
        if (this.isFast){
            this.oBall_N.frame = 38;
            this.oMusic.oAudio.rolling2Short.toPlay();
        }else{
            this.oMusic.oAudio.rolling2.toPlay();
        }
        return oPromise;
    },
    // setTransform(s){
    //     this.transform = "scale(1)";
    //     if (s < 551){
    //         this.transform = `scale(${s / 550}) rotate(90deg) translate(1%,11%)`
    //     }
    // },
};


export class BallMaker {
    constructor() {}
    init(oCanvasDOM) {
        // 入参是 canvas 的 dom 
        this.live = true;
        this.canvas = oCanvasDOM;
        this.ctx = oCanvasDOM.getContext("2d");
        this.ball = {
            x: this.canvas.width / 2,
            y: 95,
            r: 11.5,
        };
        if (this.ctx) this.ctx.fillStyle = "#FFF";
        this.frame = 0;
        this.grav = 6;
        this.dansity = -1.4;
        this.acel = 0;
    }
    startAnim() {
        this.ball.y = 125;
        this.frame = 0;
        this.dansity = -1.4;
        this.acel = 0;
    }
    update() {
        if (!this.live || !this.canvas || !this.ctx) {
            console.log('update returned');
            return;
        }
        this.frame++;
        if (this.frame > 38){
            this.acel += this.grav;
            this.ball.y -= this.acel;
            if (this.ball.y <= 95){
                if (this.acel <= this.grav){
                    this.acel = 0;
                    this.ball.y = 95;
                }else{
                    this.ball.y = 95;
                    this.acel *= this.dansity;
                    this.dansity < -.98 && (this.dansity += .6);
                }
            }
        }
    }
    redraw() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctx.beginPath();
        this.ctx.arc(this.ball.x, this.ball.y, this.ball.r, 0, 2 * Math.PI);
        // console.log(this.ball.x, this.ball.y, this.ball.r, 0, ~~(2 * Math.PI));
        this.ctx.fill();
    }
}

export const oMethods = {
    ...oAboutPlaceBet,
    ...oDragAndDrop,
    ...oFn4User,
    ...oFnBorrowed,
    ...oFn4Program,
    ...oMobileFn,
};



// ↓ number to number 
const n2n = Object.freeze({
    0: 0,
    32: 36,
    15: 35,
    19: 34,
    4: 33,
    21: 32,
    2: 31,
    25: 30,
    17: 29,
    34: 28,
    6: 27,
    27: 26,
    13: 25,
    36: 24,
    11: 23,
    30: 22,
    8: 21,
    23: 20,
    10: 19,
    5: 18,
    24: 17,
    16: 16,
    33: 15,
    1: 14,
    20: 13,
    14: 12,
    31: 11,
    9: 10,
    22: 9,
    18: 8,
    29: 7,
    7: 6,
    28: 5,
    12: 4,
    35: 3,
    3: 2,
    26: 1
});

